import React from 'react';
import logo2 from '../Assets/logo2.png';

const Navbar = ({ scrollToRef }) => {
  const handleScroll = () => {
    if (scrollToRef?.current) {
      scrollToRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="flex justify-between items-center sm:px-11 px-6 py-3 sm:py-6 bg-gradient-to-r from-[#00B7E6] via-[#00CBDF] to-[#00DCD8] shadow-md">
      <img src={logo2} alt="logo" className="h-10 pt-1 w-max sm:h-14" />

      <div className="relative">
        <button
          onClick={handleScroll}
          className="px-5 py-1 sm:px-6 sm:py-2.5 rounded-full border-2 border-white text-white font-semibold shadow-lg bg-[#00C4FF] hover:bg-[#00B4F1] transition-all duration-300"
        >
          Call Us
        </button>
        <span className="absolute -top-0.5 -right-1 h-4 w-4 rounded-full bg-blue-300 animate-ping"></span>
        <span className="absolute -top-0.5 -right-1 h-4 w-4 rounded-full bg-blue-500 shadow-md"></span>
      </div>
    </div>
  );
};

export default Navbar;
